module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.loading.organizationSettings) ? _c('spinner') : _c('form', {
    attrs: {
      "data-vv-scope": "email-settings"
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Logo")]), _vm._v(" "), _c('image-render', {
    attrs: {
      "field": {
        name: 'email-logo',
        button: 'Upload logo'
      },
      "folder": "organization_settings"
    },
    model: {
      value: (_vm.data.logo),
      callback: function($$v) {
        _vm.$set(_vm.data, "logo", $$v)
      },
      expression: "data.logo"
    }
  })], 1), _vm._v(" "), _c('form-input', {
    attrs: {
      "label": "Reply to address",
      "name": "email-address",
      "validation-scope": "email-settings",
      "validators": "email|required"
    },
    model: {
      value: (_vm.data.emailAddress),
      callback: function($$v) {
        _vm.$set(_vm.data, "emailAddress", $$v)
      },
      expression: "data.emailAddress"
    }
  }), _vm._v(" "), _c('form-input', {
    attrs: {
      "label": "Organization name",
      "name": "organization-name",
      "validation-scope": "email-settings",
      "validators": "required"
    },
    model: {
      value: (_vm.data.organizationName),
      callback: function($$v) {
        _vm.$set(_vm.data, "organizationName", $$v)
      },
      expression: "data.organizationName"
    }
  }), _vm._v(" "), _c('form-input', {
    attrs: {
      "label": "Sender name",
      "name": "sender-name",
      "validation-scope": "email-settings",
      "validators": "required"
    },
    model: {
      value: (_vm.data.senderName),
      callback: function($$v) {
        _vm.$set(_vm.data, "senderName", $$v)
      },
      expression: "data.senderName"
    }
  }), _vm._v(" "), _c('form-input', {
    attrs: {
      "label": "Footer text",
      "name": "footer-text",
      "type": "textarea",
      "validation-scope": "email-settings",
      "validators": "required"
    },
    model: {
      value: (_vm.data.footerText),
      callback: function($$v) {
        _vm.$set(_vm.data, "footerText", $$v)
      },
      expression: "data.footerText"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d24d1fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emails/OrganizationEmailSettings.vue
// module id = 1688
// module chunks = 1